module.exports = __webpack_public_path__ + "img/accessory_shirt_12.3371a447.svg";